/**
 * Sprung nach konto.elbklar.com — den persoenlichen Einstellungen.
 *
 * Wortgleich zu `finance-web/src/lib/konto.ts`. Alles, was am User haengt
 * (Profil, Benachrichtigungen), liegt zentral dort: eine Oberflaeche statt
 * einer Kopie je App. Was an der Firma haengt — die Buchhaltungs-Einstellungen
 * unter `/einstellungen` — bleibt hier.
 *
 * `?redirect=` nimmt die Adresse mit, zu der die Konto-Seite zurueckfuehren
 * soll.
 *
 * ACHTUNG: Damit der Rueckweg auch ankommt, muss `buchhaltung.elbklar.com` in
 * `packages/account-web/src/lib/rueckweg.ts` in `ERLAUBTE_HOSTS` und
 * `APP_NAMEN` stehen. Steht es dort nicht, verwirft die Konto-Seite die
 * Adresse still (Schutz gegen Open Redirect) und der Zurueck-Knopf fehlt
 * einfach. account-web gehoert nicht zu dieser Bahn — der Eintrag steht im
 * Morgenprotokoll.
 */

const KONTO_URL = import.meta.env.VITE_ACCOUNT_URL || 'https://konto.elbklar.com';

export function kontoUrl(
  pfad: '/profil' | '/benachrichtigungen',
  zurueck: string = window.location.href,
): string {
  return `${KONTO_URL}${pfad}?redirect=${encodeURIComponent(zurueck)}`;
}
